import React from 'react'
import PrintAble from '../../components/Printable'
import dayjs from 'dayjs'

import { sides, damageType, resourceUrl } from '../../util'

export const ReportForm = ({ car, imgs, branchID = "" }) => {
    if (!car) return null
    return (
        <PrintAble>
            <div className="text-right text-lg">
                <header>
                    <img
                        src={`${resourceUrl}/banners/banner${branchID}.png`}
                        alt="header"
                        width="100%"
                        height="120mm"
                        style={{
                            position: "fixed",
                            top: "0mm",
                            left: "0mm",
                            zIndex: '-1',
                            maxHeight: '120mm'
                        }}
                    />
                </header>
                <div className="page" style={{ marginTop: "30mm" }}>
                    <h4>معلومات عامة</h4>
                    <h4>شكرا لاختيارك خدماتنا</h4>
                    <p style={{ textAlign: 'justify', direction: 'rtl' }}>
                        تكنلوجيا الفحص
                        هي طريقة مبتكرة غير تلامسية لفحص السيارة باستخدام تقنية التصوير الحراري، والتي بالإضافة إلى تحفيز السطح بمصابيح عالية الأداء، تستخدم كاميرا الأشعة تحت الحمراء فائقة الدقة لالتقاط البيانات. إلى جانب برنامج خاص يعرض نتائج قياس سيارتك بطريقة شفافة. يحدد القياس ما إذا كان الجسم قد تم إصلاحه باستخدام المعجون، أو مصبوغة ، أو مصقولة ، او تم اخفاء العيوب بأي طريقة وما إلى ذلك. تتلقى تقريرًا مكتوبًا عن نتيجة القياس
                    </p>
                </div>
                <div className="page">
                    <h4>تقرير مكتوب</h4>
                    <p style={{ textAlign: 'justify', direction: 'rtl' }}>
                        يحتوي التقرير على صور ملونة
                        للعيوب توضح الاختلاف في بنية المواد. يعرض التقرير بشكل مفصل بيانات التغييرات في بنية المواد حتى. كل لون يختص بعيب معين موجود في السيارة مثلا اللون اللحمر يرمز الى وجود الصبغ واللون الاخضر يرمز الى وجود سمكرة واللون الاصفر يرمز الى وجودتبديل الخ. بناءً على شاشة العرض الملونة ، يمكنك تقدير مدى الضرر والإصلاحات التي تمت على السيارة. اقرأ تعليقات مهندسينا لفهم نتائج قياسات
                    </p>
                </div>
                <div className="page">
                    <h4>التطبيقات</h4>
                    <p style={{ textAlign: 'justify', direction: 'rtl' }}>
                        تطبيقاتنا مخصصة للأفراد الذين يشترون سيارة مستعملة ويرغبون في معرفة وضعهم الفعلي ؛ بالنسبة للأفراد الذين يبيعون سيارة مستعملة بحالة جيدة ومن ثم يتوقعون سعر بيع أفضل ؛ لأصحاب أو بائعي السيارات الكلاسيكية وذات القيمة العالية ؛ لوكلاء السيارات - لفحص المركبات المعادة من عقود الإيجار أو للحصول على قيمة أفضل للمركبات المستعملة "المحفوظة جيدًا" ؛ لشركات التأمين - لاكتشاف الاحتيال والتحقق من جودة الإصلاحات المدفوعة ولخبراء المحكمة - للمساعدة في الحصول على آراء الخبراء.
                    </p>
                </div>
                <div className="page" style={{ margin: '5mm', }}>
                    <h4>دلائل التقرير اللونية</h4>
                    <div className="flex flex-wrap">
                        {Object.keys(damageType).map(k => (
                            <div key={k} className="flex items-center">
                                <span className="mx-2">{damageType[k].title}</span>
                                <div style={{ width: "5rem", height: "2rem", backgroundColor: damageType[k].color }}></div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="page">
                    <h4>الفحص لايشمل الكشف عن ال PDR</h4>
                    <h4>بالنسبة لبعض المركبات ال Double Coat لايعتبر ضرر في المركبة</h4>
                    <h4>الخطأ المصنعي لايعتبر ضرر في المركبة</h4>
                </div>

                <div className="pagebreak"></div>
                <div className="page" style={{ marginTop: '35mm', fontWeight: 'bold' }}>
                    تقرير الفحص النهائي :
                </div>
                <div className="flex flex-wrap justify-between">
                    <div className="flex flex-col justify-start items-start" style={{ width: '48%', margin: 0, marginBottom: '5mm', fontWeight: 'bold' }}>
                        <span className="flex flex-row justify-between" style={{ marginBottom: "2mm" }}>
                            <span className="w-1/3 leading-none" style={{ margin: 0, padding: 0 }}> الماركة : {car.brand}</span>
                            <span className="w-2/3 leading-none" style={{ margin: 0, padding: 0 }}> النوع : {car.model}</span>
                        </span>
                        <span className="flex flex-row justify-between" style={{ marginBottom: "2mm" }}>
                            <span className="w-1/3 leading-none" style={{ margin: 0, padding: 0 }}> سنة الصنع : {car.year}</span>
                            <span className="w-2/3 leading-none" style={{ margin: 0, padding: 0 }}> رقم العجلة : {car.plateNo} {car.plateType}</span>
                        </span>
                        <span className="flex flex-row justify-between" style={{ marginBottom: "2mm" }}>
                            <span className="w-full leading-none" style={{ margin: 0, padding: 0 }}> رقم الهيكل : {car?.vinNo}</span>
                            {/* <span className="w-1/2 leading-none" style={{ margin: 0, padding: 0 }}></span> */}
                        </span>
                        <span className="flex flex-row justify-between" style={{ marginBottom: "0mm" }}>
                            <span className="w-1/2 leading-none" style={{ margin: 0, padding: 0 }}> تاريخ الفحص : {dayjs(car.created_at).format("YYYY-MM-DD")}</span>
                            <span className="w-1/2 leading-none" style={{ margin: 0, padding: 0 }}> وقت الفحص : {dayjs(car.created_at).format("hh:mm a")}</span>
                        </span>
                        <span style={{ marginTop: '5mm' }}>
                            ملاحظة : نخلي مسؤوليتنا بعد انتهاء الفحص وتسليم التقرير الى الزبون.
                        </span>
                    </div>
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignContent: 'space-between', margin: '10px' }}>
                        <div style={{ width: '49%', margin: 0 }}>
                            <div className="page justify-between" style={{ width: '100%', margin: '0mm', marginBottom: '2mm', border: '1px solid gray', borderRadius: '0.25rem', display: 'flex', flexDirection: 'column', flexWrap: 'wrap', justifyContent: 'flex-start' }}>
                                <img src={imgs.side2} width="100%" height="200mm" alt="side2" />
                                <div className="text-center" style={{ width: '100%', margin: '2mm' }}>
                                    <h5 style={{ margin: '0mm', marginBottom: '2mm', padding: '0mm' }}>{sides.side2}</h5>
                                    <p style={{ textAlign: 'justify', direction: 'rtl', width: '95%', margin: '0mm' }}>
                                        {car.report.side2Note}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div style={{ width: '49%', margin: 0 }}>
                            <div className="page justify-between" style={{ width: '100%', margin: '0mm', marginBottom: '2mm', border: '1px solid gray', borderRadius: '0.25rem', display: 'flex', flexDirection: 'column', flexWrap: 'wrap', justifyContent: 'flex-start' }}>
                                <img src={imgs.side4} width="100%" height="200mm" alt="side4" />
                                <div className="text-center" style={{ width: '100%', margin: '2mm' }}>
                                    <h5 style={{ margin: '0mm', marginBottom: '2mm', padding: '0mm' }}>{sides.side4}</h5>
                                    <p style={{ textAlign: 'justify', direction: 'rtl', width: '95%', margin: '0mm' }}>
                                        {car.report.side4Note}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center', margin: '10px' }}>
                        <div style={{ width: '75%', margin: 0 }}>
                            <div className="page justify-between" style={{ width: '100%', margin: '0mm', marginBottom: '2mm', border: '1px solid gray', borderRadius: '0.25rem', display: 'flex', flexDirection: 'column', flexWrap: 'wrap', justifyContent: 'flex-start' }}>
                                <img src={imgs.side5} width="100%" height="250mm" alt="side5" />
                                <div className="text-center" style={{ width: '100%', margin: '2mm' }}>
                                    <h5 style={{ margin: '0mm', marginBottom: '2mm', padding: '0mm' }}>{sides.side5}</h5>
                                    <p style={{ textAlign: 'justify', direction: 'rtl', width: '95%', margin: '0mm' }}>
                                        {car.report.side5Note}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='page'>
                        <div className="flex flex-col justify-start items-start" style={{ width: '48%', marginTop: '25mm', marginBottom: '5mm', fontWeight: 'bold' }}>
                            <span className="flex flex-row justify-between" style={{ marginBottom: "2mm" }}>
                                <span className="w-1/3 leading-none" style={{ margin: 0, padding: 0 }}> الماركة : {car.brand}</span>
                                <span className="w-2/3 leading-none" style={{ margin: 0, padding: 0 }}> النوع : {car.model}</span>
                            </span>
                            <span className="flex flex-row justify-between" style={{ marginBottom: "2mm" }}>
                                <span className="w-1/3 leading-none" style={{ margin: 0, padding: 0 }}> سنة الصنع : {car.year}</span>
                                <span className="w-2/3 leading-none" style={{ margin: 0, padding: 0 }}> رقم العجلة : {car.plateNo} {car.plateType}</span>
                            </span>
                            <span className="flex flex-row justify-between" style={{ marginBottom: "2mm" }}>
                                <span className="w-full leading-none" style={{ margin: 0, padding: 0 }}> رقم الهيكل : {car?.vinNo}</span>
                                {/* <span className="w-1/2 leading-none" style={{ margin: 0, padding: 0 }}></span> */}
                            </span>
                            <span className="flex flex-row justify-between" style={{ marginBottom: "0mm" }}>
                                <span className="w-1/2 leading-none" style={{ margin: 0, padding: 0 }}> تاريخ الفحص : {dayjs(car.created_at).format("YYYY-MM-DD")}</span>
                                <span className="w-1/2 leading-none" style={{ margin: 0, padding: 0 }}> وقت الفحص : {dayjs(car.created_at).format("hh:mm a")}</span>
                            </span>
                            <span style={{ marginTop: '5mm' }}>
                                ملاحظة : نخلي مسؤوليتنا بعد انتهاء الفحص وتسليم التقرير الى الزبون.
                            </span>
                        </div>
                        <div style={{ width: '100%' }}>
                            <div style={{ margin: '5mm', width: '100%', display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
                                <div style={{ width: '70%', margin: 0 }}>
                                    <div className="page justify-between" style={{ width: '100%', margin: '0mm', marginBottom: '2mm', border: '1px solid gray', borderRadius: '0.25rem', display: 'flex', flexDirection: 'column', flexWrap: 'wrap', justifyContent: 'flex-start' }}>
                                        <img src={imgs.side1} width="100%" height="250mm" alt="side1" />
                                        <div className="text-center" style={{ width: '100%', margin: '2mm' }}>
                                            <h5 style={{ margin: '0mm', marginBottom: '2mm', padding: '0mm' }}>{sides.side1}</h5>
                                            <p style={{ textAlign: 'justify', direction: 'rtl', width: '95%', margin: '0mm' }}>
                                                {car.report.side1Note}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div style={{ width: '70%' }}>
                                    <div className="page justify-between" style={{ width: '100%', margin: '0mm', marginBottom: '2mm', border: '1px solid gray', borderRadius: '0.25rem', display: 'flex', flexDirection: 'column', flexWrap: 'wrap', justifyContent: 'flex-start' }}>
                                        <img src={imgs.side3} width="100%" height="250mm" alt="side3" />
                                        <div className="text-center" style={{ width: '100%', margin: '2mm' }}>
                                            <h5 style={{ margin: '0mm', marginBottom: '2mm', padding: '0mm' }}>{sides.side3}</h5>
                                            <p style={{ textAlign: 'justify', direction: 'rtl', width: '95%', margin: '0mm' }}>
                                                {car.report.side3Note}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <footer>
                    <img
                        src={`${resourceUrl}/banners/footer${branchID}.png`}
                        alt="footer"
                        width="100%"
                        height="120mm"
                        style={{
                            position: "fixed",
                            bottom: '0mm',
                            left: '0mm',
                            maxHeight: '120mm'
                        }}
                    />
                    <div style={{ position: 'fixed', bottom: '10mm', right: '0', margin: '5mm' }}>
                        {`تقرير الفحص النهائي للعجلة المرقمة
                    ${car.plateNo} - ${car.plateType}
                    بتاريخ ${dayjs(car.created_at).format("YYYY-MM-DD")}
                    في الساعة ${dayjs(car.created_at).format("hh:mm a")}
                    `}
                    </div>
                </footer>

            </div>
        </PrintAble >
    )
}
